import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import RootApp from './App';
import reportWebVitals from './reportWebVitals';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from '@redux-devtools/extension';
import createRootReducer, { store } from './Reducers';
import rootSaga from './Sagas';
import { Provider } from 'react-redux';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import capacitorStorage, { CapacitorCache } from 'Utils/CapacitorStorage';
import { isCapacitorNative } from 'Utils/Constants';
import { Amplify } from 'aws-amplify';
import { getUser } from 'Utils/Auth';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import CapacitorStorage from 'Utils/CapacitorStorage';
import { setupAxiosInterceptors } from 'Utils/axiosInterceptor';

const region = process.env.REACT_APP_COGNITO_AWS_REGION;
const cognitoUserPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID;
const cognitoClientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
// const cognitoGuestRoleArn = process.env.REACT_APP_COGNITO_GUEST_ROLE_ARN;
const awsIdentityPoolId = process.env.REACT_APP_RUM_IDENTITY_POOL_ID;
const awsPinpointApplicationId = process.env.REACT_APP_PINPOINT_APPLICATION_ID;

const theme = createTheme({      
  typography: {
    button: {
      textTransform: 'none'
    }
  }
});

const rootNode = document.getElementById('root');

const persistor = persistStore(store);

const awsConfig = {
  Auth: {
    Cognito: {
      region: region!,
      userPoolId: cognitoUserPoolId!,
      userPoolClientId: cognitoClientId!,
      identityPoolId: awsIdentityPoolId!,
      // do not add oauth config. OAuth is now handled by react-oidc-context
    }
  },
  Analytics: {
    AWSPinpoint: {
      appId: awsPinpointApplicationId,
      region: region
    },
  }
};
Amplify.configure(awsConfig);
// no need to use the same sharded cache for amplify - it shards itself
const amplifyCache = new CapacitorCache();
cognitoUserPoolsTokenProvider.setKeyValueStorage(amplifyCache);

// Setup axios interceptors to handle 401 errors and token refresh
setupAxiosInterceptors();

new Promise((resolve) => {

  return getUser().then((user) => {
    console.log("Initializing CapacitorCache with userId:", user?.attributes.sub);
    return capacitorStorage.init().then(() => {
      resolve(true);
    }).catch((error) => {
      console.error("Error initializing Capacitor storage:", error);
      resolve(false);
    });
  })
}).then(() => {
    const root = createRoot(rootNode!);
    root.render(
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <ThemeProvider theme={theme}>
            <RootApp store={store} />
          </ThemeProvider>
        </PersistGate>
      </Provider>
    );

    

    reportWebVitals();
})

